export const extractSignXml = (signedXml: string): string => {
  const namespaced = signedXml.match(
    /<(?:[\w]+:)?Signature\b[\s\S]*?<\/(?:[\w]+:)?Signature>/,
  );
  if (namespaced) return namespaced[0];

  const wrapper = signedXml.match(/<signature\b[^>]*>[\s\S]*?<\/signature>/i);
  if (wrapper) return wrapper[0];

  throw new Error("Signature tag not found in XML");
};
